import styled from "@emotion/styled";

import { ContentItemHomeHeroArticle } from "scmp-app/components/content/content-item-render/variants/home-hero-article";

export const StyledContentItemHomeHeroArticle = styled(ContentItemHomeHeroArticle)``;
